import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { initSafariPolyfills } from './utils/safariPolyfills';
import { initSafariOptimizations, monitorSafariPerformance } from './utils/safariOptimizations';

// Initialize Safari polyfills before anything else
console.log('[Safari] Initializing polyfills...');
const polyfillsLoaded = initSafariPolyfills();
if (!polyfillsLoaded) {
  console.error('[Safari] Critical polyfills failed to load - app may not work on older Safari versions');
}

// Initialize Safari optimizations
console.log('[Safari] Initializing optimizations...');
const optimizationsLoaded = initSafariOptimizations({
  enableLazyImages: true,
  enableBundleSplitting: true,
  enableMemoryOptimization: true,
  enableNetworkOptimization: true
});

if (optimizationsLoaded) {
  console.log('[Safari] Performance optimizations enabled');
  monitorSafariPerformance();
} else {
  console.warn('[Safari] Some optimizations failed to load');
}

// Safari-compatible React rendering
const rootElement = document.getElementById('root') as HTMLElement;

// Try modern ReactDOM.createRoot first, fallback to legacy render
let root: any;
try {
  if (ReactDOM.createRoot) {
    root = ReactDOM.createRoot(rootElement);
    root.render(<App />);
    console.log('[Safari] Using modern React 18 rendering');
  } else {
    // Fallback for older React versions
    (ReactDOM as any).render(<App />, rootElement);
    console.log('[Safari] Using legacy React rendering');
  }
} catch (error) {
  console.error('[Safari] Error during React rendering:', error);
  
  // Last resort - try legacy render
  try {
    (ReactDOM as any).render(<App />, rootElement);
    console.log('[Safari] Fallback to legacy rendering successful');
  } catch (fallbackError) {
    console.error('[Safari] All rendering methods failed:', fallbackError);
    
    // Show error message to user
    rootElement.innerHTML = `
      <div style="padding: 20px; text-align: center; font-family: Arial, sans-serif;">
        <h2>Browser Compatibility Issue</h2>
        <p>This app requires a newer version of Safari or iOS.</p>
        <p>Please update your browser or try using Chrome.</p>
        <button onclick="window.location.reload()" style="padding: 10px 20px; font-size: 16px;">
          Try Again
        </button>
      </div>
    `;
  }
}

// Register service worker for offline support and caching
// This enables offline functionality and improves performance
if (process.env.NODE_ENV === 'production') {
  serviceWorkerRegistration.register({
    onSuccess: (registration) => {
      console.log('[Service Worker] Registered successfully:', registration);
    },
    onUpdate: (registration) => {
      console.log('[Service Worker] Update available:', registration);
      // Optionally notify user about update
      if (window.confirm('New version available! Reload to update?')) {
        window.location.reload();
      }
    }
  });
} else {
  // Unregister in development to avoid caching issues
  serviceWorkerRegistration.unregister();
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(); 